import NavBar from "./NavBar";
import "./WhyOakmereCapital.css";

function WhyOakmereCapital() {
  return (
    <div className="WhyOakmereCapital">
      <NavBar />
      <div className="PageTitleBanner">
        <h1>Why Oakmere Capital</h1>
      </div>
      <div className="WhyCards">
        <div className="WhyCard">
          <h3>Truly Independent Advice</h3>
          <p>
            Oakmere has no affiliation or ties to third parties, which aligns
            our interests with yours. Our only incentive is to provide you with
            the best opportunities to meet your objectives.
          </p>
        </div>
        <div className="WhyCard">
          <h3>Personal Service</h3>
          <p>
            Building on experience from a family office environment, our
            approach is centered around private individuals and their families.
            This ensures an intimate understanding of your personal
            circumstances.
          </p>
        </div>
        <div className="WhyCard">
          <h3>Technical Expertise</h3>
          <p>
            An important compliment to our service is an in-depth knowledge of
            markets, managers and portfolio construction. We are experienced in
            all these areas, and they form an integral part of our process.
          </p>
        </div>
        <div className="WhyCard">
          <h3>Transparent Fee Structure</h3>
          <p>
            All fees are fully disclosed upfront. It is important to us that our
            clients understand what they are paying and what services they
            receive in return.
          </p>
        </div>
      </div>
      <footer className="ComplianceFooter">
        <p>
          Oakmere Capital is a Juristic Representative of Yellowwood Private
          Wealth. Yellowwood Private Wealth is an authorised financial services
          provider.
        </p>
        <p>FSP No 49879</p>
        <p>
          Copies of our complaints and conflicts of interest policies are
          available upon request.
        </p>
      </footer>
    </div>
  );
}

export default WhyOakmereCapital;
